import { useState } from 'react';

import { Sieve } from '../Sieve';

/** Нижний лист. Те же ключи localStorage, что у стола: внутри тот же Sieve. */
export function PhoneSieve(props: {
  hidden: number;
  byProfile: number;
  byExclude?: number;
}): React.ReactElement {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className="ph-sieve-btn" onClick={() => setOpen(true)}>
        фильтры
      </button>
      {open && (
        <div className="ph-sheet" role="dialog" aria-label="фильтры">
          <div className="ph-sheet__bar">
            <b>фильтры</b>
            <button type="button" onClick={() => setOpen(false)}>закрыть</button>
          </div>
          <div className="ph-sheet__body">
            <Sieve hidden={props.hidden} byProfile={props.byProfile} byExclude={props.byExclude} />
          </div>
        </div>
      )}
    </>
  );
}
